import { el, setChildren } from 'redom';

import { formatToLongDate } from 'utilities/date';

class DevelopmentConsole {

  constructor() {

    this.logs = [];

    this.el = el('.streamer-development-console');

  }

  log(text) {

    const formatedDateTime = formatToLongDate(new Date());

    this.logs.unshift(el('p.streamer-development-console-log', `${formatedDateTime} ${text}`));

    if (this.logs.length > 100) {
      this.logs.pop();
    }

    setChildren(this.el, this.logs);

  }

}

export default DevelopmentConsole;